export function timeToDate(date: string): Date {
  return new Date(date.replace(" ", "T").concat("Z"));
}

export function dateToTime(date: Date): string {
  let convertedDate = new Date(date).toJSON();
  convertedDate = convertedDate.substring(0, convertedDate.length - 1);
  convertedDate = convertedDate.split(".")[0];
  return convertedDate.replace("T", " ");
}

function formatDateOnRange(dateInput: Date, type: "from" | "to"): Date {
  const year = dateInput.getFullYear();
  const month = dateInput.getMonth();
  const date = dateInput.getDate();
  switch (type) {
    case "from":
      return new Date(year, month, date, 0, 0, 0);
    case "to":
      return new Date(year, month, date, 23, 59, 59);
  }
}

export function formatDateForQuery(dateFrom: Date, dateTo: Date) {
  let df = dateToTime(formatDateOnRange(dateFrom, "from"));
  let dt = dateToTime(formatDateOnRange(dateTo, "to"));
  return df + "," + dt;
}
